import $ from 'jquery';
import 'jquery';
import './bootstrap';
import smoothscroll from 'smoothscroll-polyfill';


import initSliders from "./slider";
//import lazyLoadIframes from "./lazyLoadIframes";
import scrollTop from "./top";
import parallaxOff from "./ifTouchDeviceParallaxOff";
import switchLanguage from "./languageSwitch";
import menuInit from './menu';
import setScrollPadding from "./setScrollPadding";

$(document).ready(() => {


    //lazyLoadIframes();
    initSliders();
    scrollTop();
    parallaxOff();
    switchLanguage();
    menuInit();
    setScrollPadding();
    smoothscroll.polyfill();

});
let currentWidth = window.innerWidth;
window.addEventListener('resize', () => {
    if(currentWidth === window.innerWidth) return;
    menuInit();
    setScrollPadding();


});
window.addEventListener('orientationchange', () => {
    menuInit();
    setScrollPadding();
});